<template>
  <div id="Lgx02714010258294821618566">
    <div class="relative flex">
      <img
        src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/casp-plus/02714010258294821618566/graphic.png"
        alt="Logo"
        draggable="false"
        width="100%"
        height="100%"
      />

      <span
        class="router"
        style="width: 26.7%; height: 7.5%; top: 15.25%; left: 8.125%; border: 2px solid #0053ff; border-radius: 0.8rem"
        @click="vpnConcentrator.popupOpen = true"
      />
      <span
        class="router"
        style="width: 6.7%; height: 19.45%; bottom: 20.5%; left: 25.1%; border: 2px solid #0053ff; border-radius: 1.2rem"
        @click="aaaServer.popupOpen = true"
      />
    </div>

    <movable-popup
      refVal="vpnConcentratorPopup"
      title="VPN Concentrator"
      :active="vpnConcentrator.popupOpen"
      v-on:close="vpnConcentrator.popupOpen = false"
      style="width: 30rem"
    >
      <template v-slot:content>
        <div class="flex flex-col gap-3">
          <v-select
            class="w-full"
            placeholder="Select the proposal from the dropdown"
            :options="popupOptions"
            v-model="vpnConcentrator.proposalValue"
            :class="{
              correct: vpnConcentrator.proposalCorrect,
              invalid: vpnConcentrator.proposalCorrect === false,
            }"
          />

          <div class="bg-dark p-3 main-border rounded-lg terminal-line text-grey">
            ...<br />
            re-ap {<br />
            ...<br />
            &nbsp;&nbsp;&nbsp;&nbsp;proposals = <br />
            &nbsp;&nbsp;&nbsp;&nbsp;...<br />
            }<br />
            ...<br />
            plugins {<br />
            &nbsp;&nbsp;&nbsp;&nbsp;eap-radius {<br />
            <span class="flex items-center gap-3">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;secret =
              <vs-input
                class="w-30"
                v-model="vpnConcentrator.secretValue"
                :class="{
                  correct: vpnConcentrator.secretCorrect,
                  invalid: vpnConcentrator.secretCorrect === false,
                }"
              />
            </span>
            <span class="flex items-center gap-3 mt-2">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;server =
              <v-select
                style="width: 14.3rem"
                placeholder="Select IP address..."
                :options="ipAddressOptions"
                v-model="vpnConcentrator.serverValue"
                :class="{
                  correct: vpnConcentrator.serverCorrect,
                  invalid: vpnConcentrator.serverCorrect === false,
                }"
              />
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;}<br />
            }<br />
            ...<br />
          </div>
        </div>
      </template>
    </movable-popup>

    <movable-popup
      refVal="aaaServerPopup"
      title="AAA Server"
      :active="aaaServer.popupOpen"
      v-on:close="aaaServer.popupOpen = false"
      style="width: 30rem"
    >
      <template v-slot:content>
        <div class="flex flex-col gap-3">
          <v-select
            class="w-full"
            placeholder="Select the eap from the dropdown"
            :options="popupOptions"
            v-model="aaaServer.eapValue"
            :class="{
              correct: aaaServer.eapCorrect,
              invalid: aaaServer.eapCorrect === false,
            }"
          />

          <div class="bg-dark p-3 main-border rounded-lg terminal-line text-grey">
            ...<br />
            eap {<br />
            ...<br />
            &nbsp;&nbsp;&nbsp;&nbsp;default_eap_type = <br />
            &nbsp;&nbsp;&nbsp;&nbsp;...<br />
            }<br />
            ...<br />
            client conc {<br />
            <span class="flex items-center gap-3">
              &nbsp;&nbsp;&nbsp;&nbsp;ip addr =
              <v-select
                style="width: 13.9rem"
                placeholder="Select IP address..."
                :options="ipAddressOptions"
                v-model="aaaServer.ipAddressValue"
                :class="{
                  correct: aaaServer.ipAddressCorrect,
                  invalid: aaaServer.ipAddressCorrect === false,
                }"
              />
            </span>
            <span class="flex items-center gap-3 mt-2 mb-2">
              &nbsp;&nbsp;&nbsp;&nbsp;secret =
              <vs-input
                class="w-30"
                v-model="aaaServer.secretValue"
                :class="{
                  correct: aaaServer.secretCorrect,
                  invalid: aaaServer.secretCorrect === false,
                }"
              />
            </span>
            <span class="flex items-center gap-3 mt-2 mb-4">
              &nbsp;&nbsp;&nbsp;&nbsp;require_message_authenticator =
              <v-select
                style="width: 8rem"
                placeholder="Yes or No"
                :options="['yes', 'no']"
                v-model="aaaServer.messageAuthenticatorValue"
                :class="{
                  correct: aaaServer.messageAuthenticatorCorrect,
                  invalid: aaaServer.messageAuthenticatorCorrect === false,
                }"
              />
            </span>
            }<br />
            ...<br />
          </div>
        </div>
      </template>
    </movable-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import MovablePopup from '../../../../../../../../components/popup/MovablePopup';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      selectedDevice: null,

      popupOptions: [
        'peap',
        'blowfish256',
        'md5',
        'aes256ccm128',
        'aes128ctr',
        'cast128',
        'camellia256ctr',
        'tls',
        'ttls',
        'psk',
        'aes245gcm128',
      ],

      ipAddressOptions: [
        '198.134.30.12',
        '10.1.0.10',
        '198.134.15.37',
        '198.134.0.2',
        '10.1.2.1',
        '198.134.3.25',
        '10.1.0.11',
        '198.134.7.49',
      ],

      vpnConcentrator: {
        popupOpen: false,

        proposalAnswer: 'tls',
        proposalValue: null,
        proposalCorrect: null,
        secretValue: null,
        secretCorrect: null,
        serverAnswer: '10.1.0.10',
        serverValue: null,
        serverCorrect: null,
      },

      aaaServer: {
        popupOpen: false,

        eapAnswer: 'tls',
        eapValue: null,
        eapCorrect: null,
        messageAuthenticatorAnswer: 'yes',
        messageAuthenticatorValue: null,
        messageAuthenticatorCorrect: null,
        ipAddressAnswer: '10.1.2.1',
        ipAddressValue: null,
        ipAddressCorrect: null,
        secretValue: null,
        secretCorrect: null,
      },
    };
  },
  methods: {
    selectDevice(router) {
      this.selectedDevice = router;
    },
    validatePassword(password) {
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d]).{8,}$/;
      return passwordRegex.test(password);
    },
    markSimulation() {
      let totalScore = 0;

      this.vpnConcentrator.proposalCorrect = this.vpnConcentrator.proposalValue === this.vpnConcentrator.proposalAnswer;
      this.vpnConcentrator.serverCorrect = this.vpnConcentrator.serverValue === this.vpnConcentrator.serverAnswer;
      this.vpnConcentrator.secretCorrect = this.validatePassword(this.vpnConcentrator.secretValue);

      this.aaaServer.eapCorrect = this.aaaServer.eapValue === this.aaaServer.eapAnswer;
      this.aaaServer.ipAddressCorrect = this.aaaServer.ipAddressValue === this.aaaServer.ipAddressAnswer;
      this.aaaServer.messageAuthenticatorCorrect = this.aaaServer.messageAuthenticatorValue === this.aaaServer.messageAuthenticatorAnswer;
      this.aaaServer.secretCorrect = this.validatePassword(this.aaaServer.secretValue);

      totalScore += this.vpnConcentrator.proposalCorrect ? 1 : 0;
      totalScore += this.vpnConcentrator.secretCorrect ? 1 : 0;
      totalScore += this.vpnConcentrator.serverCorrect ? 1 : 0;
      totalScore += this.aaaServer.eapCorrect ? 1 : 0;
      totalScore += this.aaaServer.ipAddressCorrect ? 1 : 0;
      totalScore += this.aaaServer.secretCorrect ? 1 : 0;
      totalScore += this.aaaServer.messageAuthenticatorCorrect ? 1 : 0;

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }
      this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    vSelect,
    MovablePopup,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss">
#Lgx02714010258294821618566 {
  .router {
    position: absolute;
    cursor: url('~@/assets/images/cursor/cursor-pointer.png'), auto;
  }

  .terminal-line {
    color: #f8f8f2;
    font-family: 'Fira Code', monospace;
    font-size: 0.875rem;
    line-height: 1.5;
    margin: 0.25rem 0;
  }

  .correct {
    border: 1px solid #31b952 !important;
    border-radius: 0.35rem;
  }

  .invalid {
    border: 1px solid #c93738 !important;
    border-radius: 0.35rem;
  }

  .vs-con-input {
    width: 100%;
  }
}
</style>
